<template>
  <!-- 新增采购单 -->
  <div class="container">
    <div class="left">
      <div class="title">修改采购换货单</div>
      <!-- #436AE8 -->

      <div class="codeInfo" v-if="leftContent.orderPurchaseExchangeOrderBase">
        <div>
          采购编号：<span style="color: #436ae8">{{
            leftContent.orderPurchaseExchangeOrderBase.purchaseExchangeOrderNo
          }}</span>
        </div>
        <div>
          制单人：{{ leftContent.orderPurchaseExchangeOrderBase.createdName }}
        </div>
        <div>
          制单时间：{{
            $moment(leftContent.orderPurchaseExchangeOrderBase.createdTime)
          }}
        </div>
      </div>

      <div class="leftContext">
        <el-table :data="leftContent.itemVOs">
          <el-table-column
            label="序号"
            type="index"
            width="55"
          ></el-table-column>

          <el-table-column label="供应商">
            <template slot-scope="scope">
              <span @click="openDetails(scope.row)">{{
                scope.row.supplierName
              }}</span>
            </template>
          </el-table-column>

          <el-table-column label="创建人">
            <template slot-scope="scope">
              <span @click="openDetails(scope.row)">{{
                scope.row.createdName
              }}</span>
            </template>
          </el-table-column>

          <el-table-column label="采购部门">
            <template slot-scope="scope">
              <span @click="openDetails(scope.row)">{{
                scope.row.exchangeOrgName
              }}</span>
            </template>
          </el-table-column>

          <el-table-column label="采购仓库">
            <template slot-scope="scope">
              <div @click="openDetails(scope.row)">
                <p
                  style="display: inline-block"
                  v-for="items in scope.row.depotVos1"
                  :key="items.id"
                >
                  <span>{{ items.exchangeDepotName }}</span>
                  <span v-if="scope.row.depotVos1.length > 1">,</span>
                </p>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            label="采购商品"
            show-overflow-tooltip
            min-width="120px;"
          >
            <template slot-scope="scope">
              <span @click="openDetails(scope.row)">{{
                scope.row.exchangeProdName
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="商品类型">
            <template slot-scope="scope">
              <span
                @click="openDetails(scope.row)"
                v-if="scope.row.exchangeProdType == 1"
                >商品</span
              >
              <span @click="openDetails(scope.row)" v-else>赠品</span>
            </template>
          </el-table-column>

          <el-table-column label="商品图片">
            <template slot-scope="scope">
              <img
                v-if="scope.row.exchangeProdImage"
                @click="openDetails(scope.row)"
                style="width: 50px; height: 50px"
                :src="ImgHttps + scope.row.exchangeProdImage"
                alt=""
              />
              <span v-else>/</span>
            </template>
          </el-table-column>

          <el-table-column label="品牌">
            <template slot-scope="scope">
              <span @click="openDetails(scope.row)">{{
                scope.row.exchangeProdBrandName
              }}</span>
            </template>
          </el-table-column>

          <el-table-column label="规格">
            <template slot-scope="scope">
              <span @click="openDetails(scope.row)">{{
                scope.row.exchangeProdSpecificationName
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="采购金额">
            <template slot-scope="scope">
              <span @click="openDetails(scope.row)">{{
                scope.row.exchangeProdPrice
              }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="right">
      <div class="title">操作</div>
      <div class="rightContext" style="border: 0">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="采购部门">
            <div class="selectTree">
              <treeselect
                :options="options"
                v-model="form.bumenCode"
                search-nested
                :normalizer="normalizer"
                noResultsText="未找到"
                placeholder="请选择"
                :disabled="jage == 1 ? false : true"
              >
              </treeselect>
            </div>
          </el-form-item>
          <el-form-item label="供应商">
            <el-input
              size="small"
              placeholder="请输入供应商名称"
              :value="form.supplierName"
              supplierName
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="采购类型">
            <el-input
              size="small"
              placeholder="请输入采购类型"
              :value="form.exchangeProdType == 1 ? '商品' : '赠品'"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="采购商品">
            <el-input
              size="small"
              placeholder="请输入采购商品"
              :value="form.exchangeProdName"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="采购规格">
            <el-input
              size="small"
              placeholder="请输入采购规格"
              :value="form.exchangeProdSpecificationName"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="采购品牌">
            <el-input
              size="small"
              placeholder="请输入采购品牌"
              :value="form.exchangeProdBrandName"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="采购金额">
            <el-input
              size="small"
              placeholder="请输入采购金额"
              :value="form.exchangeProdPrice * form.exchangeProdQuantity"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="采购数量">
            <el-input
              type="number"
              size="small"
              placeholder="请输入采购数量"
              :value="canOperateQuantityAll(form.depotVos1)"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="入库仓库">
            <div
              v-for="(ite, index) in form.depotVos1"
              :key="index"
              v-if="ite.type == 0 || ite.type == undefined"
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                min-width: 430px;
              "
            >
              <el-select
                :value="ite.exchangeDepotName"
                size="mini"
                value-key="purchaseDepotId"
                placeholder="请选择"
                @change="myWareListChange($event, ite)"
                :disabled="jage == 1 ? false : true"
              >
                <el-option
                  v-for="item in wareList.list"
                  :key="item.id"
                  :label="item.name"
                  :value="item"
                >
                </el-option>
              </el-select>
              <div style="display: flex; align-items: center">
                可操作数:{{
                  ite.orderPurchaseInOrderProdDepot.canOperateQuantity +
                  ite.exchangeDepotQuantity -
                  ite.exchangeDepotQuantity1
                }}
                <el-input-number
                  size="mini"
                  :min="0"
                  style="margin-right: 10px; margin-left: 10px"
                  placeholder="请输入库存数量"
                  v-model="ite.exchangeDepotQuantity1"
                  :max="
                    ite.orderPurchaseInOrderProdDepot.canOperateQuantity +
                    ite.exchangeDepotQuantity
                  "
                  @change="inputChange(ite)"
                ></el-input-number>

                <i
                  v-if="jage == 1"
                  class="el-icon-remove-outline"
                  style="cursor: pointer"
                  @click="deleteMyWare(ite, ite.type != undefined ? 1 : 0)"
                ></i>
              </div>
            </div>
            <i
              v-if="jage == 1"
              class="el-icon-circle-plus-outline"
              style="cursor: pointer"
              @click="addMyWareList(form)"
            ></i>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              maxlength="255"
              placeholder="请输入备注"
              type="textarea"
              v-model="textarea"
            ></el-input>
          </el-form-item>
        </el-form>
        <p style="text-align: right; margin-top: 50px">
          <el-button type="primary" size="mini" @click="submit">提交</el-button>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  components: { Treeselect },
  data() {
    return {
      table: {
        list: [],
        pageNo: 1,
        pageSize: 10,
      },
      form: {}, //表单数据
      wareList: {
        list: [],
      },
      leftContent: "",
      normalizer(node) {
        return {
          id: node.orgCode,
          label: node.orgName,
          children: node.children,
        };
      },
      options: [],
      jage: "", //待提交的修改1 已完成的修改 2
      textarea: "",
    };
  },
  created() {
    this.jage = this.$route.query.jage;
    // console.log(this.jage +"---jage")
    this.listAxios(this.$route.query.purchaseExchangeOrderNo);
    this.department();
    this.getWareList();
  },
  // activated() {

  // },
  methods: {
    canOperateQuantityAll(e) {
      let sum = 0;
      if (e) {
        e.forEach((res) => {
          sum += res.exchangeDepotQuantity1;
        });
      }
      return sum;
    },
    openDetails(row) {
      this.form = row;
    },
    // 部门选择列表
    department() {
      this.axios
        .post(
          "/sys/v1/org/tree/select",
          {
            request: {
              orgName: "",
              orgType: "",
            },
            version: "",
          },
          {
            headers: {
              isLoading: false,
            },
          }
        )
        .then((res) => {
          if (res.code == 0) {
            this.options = res.data;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    // 数据请求 详情
    listAxios(purchaseExchangeOrderNo) {
      this.axios
        .post("/order/v1/purchase/exchange/order/item/list", {
          request: {
            purchaseExchangeOrderNo: purchaseExchangeOrderNo,
          },
        })
        .then((res) => {
          if (res.code == 0) {
            this.textarea = res.data.orderPurchaseExchangeOrderBase.comment;
            this.$set(
              res.data,
              "itemVOs",
              res.data.orderPurchaseExchangeOrderItem
            );
            for (let i in res.data.itemVOs) {
              res.data.itemVOs[i].depotVos1 = JSON.parse(
                JSON.stringify(
                  res.data.itemVOs[i].orderPurchaseExchangeOrderProdDepotList
                )
              );
              for (let k of res.data.itemVOs[i].depotVos1) {
                k.exchangeDepotQuantity1 = k.exchangeDepotQuantity;
              }
              console.log(res.data.itemVOs[i].depotVos1);
              res.data.itemVOs[i].fileListImg = [];
              res.data.itemVOs[i].bumen = [];
              res.data.itemVOs[i].bumenCode =
                res.data.itemVOs[i].exchangeOrgCode;
            }
            this.leftContent = res.data;
            this.form = this.leftContent.itemVOs[0];
          } else {
            this.$message.error(res.message);
          }
        });
    },
    addMyWareList(param) {
      if (this.form.depotVos1.length < this.wareList.list.length) {
        this.form.depotVos1.push({
          // "createdBy": "",
          // "createdTime": "",
          // "id": '',
          purchaseDepotId: "", //采购仓库ID
          purchaseDepotName: "",
          purchaseOrderItemId: "",
          purchaseOrderNo: param.purchaseOrderNo,
          purchaseProdId: param.purchaseProdId,
          purchaseProdInDepotQuantity: 0,
          purchaseProdName: param.purchaseProdName,
          purchaseProdNotInDepotQuantity: 0,
          purchaseProdQuantity: 0, //采购商品数量
          purchaseProdType: "",
          status: "",
          updatedBy: "",
          updatedTime: "",
        });
      } else {
        this.$message.warning("不能再加了仓库只有这些");
      }
    },
    beforeUploadImg(file) {
      return new Promise((resolve, reject) => {
        let _URL = window.URL || window.webkitURL;
        let isLt2M = file.size / 1024 / 1024 > 4; // 判定图片大小是否小于4MB
        // 这里需要计算出图片的长宽
        let img = new Image();
        img.onload = function () {
          file.width = img.width; // 获取到width放在了file属性上
          file.height = img.height; // 获取到height放在了file属性上
          let valid = img.width > 2000; // 图片宽度大于2000
          // console.log(11, file)
          // 这里我只判断了图片的宽度,compressAccurately有多个参数时传入对象
          if (valid || isLt2M) {
            imageConversion
              .compressAccurately(file, {
                size: 400,
                width: 2000,
              })
              .then((res) => {
                // console.log(33, res)
                resolve(res);
              });
          } else resolve(file);
        }; // 需要把图片赋值
        img.src = _URL.createObjectURL(file);
      });
    },
    imgUpload(fileObj) {
      let length = this.form.fileListImg.length;
      let formData = new FormData();
      formData.append("file", fileObj.file);

      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      if (length <= 5) {
        this.axios
          .post(
            "/sys/v1/common/upload/files?pathName=internalSystem",
            formData,
            config,
            {
              headers: {
                isLoading: false,
              },
            }
          )
          .then((res) => {
            console.log(res);
            if (res.code == 0) {
              // this.imageUrl = res.data.url;
              let obj = {
                img: res.data.url,
                // creattime: new Date().toLocaleDateString(),
              };
              this.form.fileListImg.push(obj);
            } else {
              this.$message.error(res.message);
            }
          });
      } else {
        this.$message.warning("图片条数不能超过10条");
      }
    },
    //删除现在的仓库
    deleteMyWare(e, t) {
      if (t) {
        let temp = this.form.depotVos1.find(
          (res) => res.purchaseDepotId === e.warId
        );
        temp.type = 1;
      } else {
        this.form.depotVos1.splice(
          this.form.depotVos1.findIndex(
            (res) => res.purchaseDepotId == e.warId
          ),
          1
        );
      }
      this.numberTotalWare();
    },
    //自己选择的仓库修改了
    myWareListChange(e1, e2) {
      let temp = this.form.depotVos1.find(
        (res) => e1.id == res.purchaseDepotId
      );
      if (temp) {
        if (temp.type) {
          this.$message.warning("该仓库已删除不能选");
        } else {
          this.$message.warning("该仓库已存在");
        }
        return;
      }
      e2.purchaseDepotId = e1.id + "";
      e2.purchaseDepotName = e1.name;
      this.$forceUpdate();
    },
    inputChange(e) {
      this.numberTotalWare();
    },
    // 计算采购总库存
    numberTotalWare() {
      let numberTotal = 0;
      for (let i in this.form.depotVos1) {
        if(this.form.depotVos1[i].exchangeDepotQuantity1){
          numberTotal += this.form.depotVos1[i].exchangeDepotQuantity1;
        }else{
          this.form.depotVos1[i].exchangeDepotQuantity1 = 0;
        }
      }
      this.form.exchangeProdQuantity = numberTotal;
    },
    getWareList() {
      this.axios
        .post("order/comm/commWarehouse/list",{
        pageSize:999,
        pageNo:1
      }, {
          isLoading: false,
        })
        .then((res) => {
          //仓库数据接口
          this.wareList = res.data;
          this.wareList.list = this.wareList.list.reverse();
        });
    },

    // 数据提交 已完成修改
    submit: _.debounce(function () {
      // 数据处理
      let itemList = [];
      for (let i in this.leftContent.itemVOs) {
        if (
          this.leftContent.itemVOs[i].bumenCode == "" ||
          this.leftContent.itemVOs[i].bumenCode == null
        ) {
          this.$message.warning("请选择采购的部门");
          return false;
        } else if (
          this.leftContent.itemVOs[i].depotVos1[0].purchaseDepotId == "" &&
          this.leftContent.itemVOs[i].depotVos1[0].purchaseProdQuantity == 0
        ) {
          this.$message.warning("请选择采购入库的仓库与数量");
          return false;
        }
        this.leftContent.itemVOs[i].purchaseImage1 = ""; //初始化值

        // 图片处理
        for (let j in this.leftContent.itemVOs[i].fileListImg) {
          this.leftContent.itemVOs[i].purchaseImage1 +=
            this.leftContent.itemVOs[i].fileListImg[j].img + ",";
        }

        this.getMenuBtnList(
          this.options,
          this.leftContent.itemVOs[i].bumen,
          this.leftContent.itemVOs[i].bumenCode
        );

        // 待提交修改完成
        this.leftContent.itemVOs[i].warehouses1 = [];
        for (let k in this.leftContent.itemVOs[i].depotVos1) {
          this.leftContent.itemVOs[i].warehouses1.push({
            id: this.leftContent.itemVOs[i].depotVos1[k].inOrderProdDepotId,
            depotQuantity: this.leftContent.itemVOs[i].depotVos1[k]
              .exchangeDepotQuantity1,
          });
        }

        itemList.push({
          id: this.leftContent.itemVOs[i].orderPurchaseInOrderItemId,
          depotBaseDtoList: this.leftContent.itemVOs[i].warehouses1,
          exchangeProdAmount:
            this.leftContent.itemVOs[i].exchangeProdPrice *
            this.leftContent.itemVOs[i].exchangeProdQuantity,
          exchangeProdQuantity: this.leftContent.itemVOs[i]
            .exchangeProdQuantity,
        });
      }
      //待提交修改
      this.axios
        .post("/order/v1/purchase/exchange/order/update", {
          request: {
            purchaseExchangeOrderNo: this.leftContent
              .orderPurchaseExchangeOrderBase.purchaseExchangeOrderNo,
            addPurchaseExchangeOrderDtoList: itemList,
            comment: this.textarea,
          },
        })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("修改成功!");
            this.$router.push({ name: "purchasingExchangeList" });
          } else {
            this.$message.error(res.message);
          }
        });
    }, 300),

    // 递归
    getMenuBtnList(menuTreeList, menuList, code) {
      for (let item of menuTreeList) {
        if (item.orgCode == code) {
          menuList.push({
            lable: item.orgName,
            orgCode: item.orgCode,
            type: item.type,
          });
        } else if (item.children && item.children.length > 0) {
          this.getMenuBtnList(item.children, menuList, code);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  display: flex;
  height: 100%;
  .left {
    overflow: auto;
    background: #fff;
    padding: 10px;
    flex: 1;
    min-width: 600px;
    .title {
      color: #6b6b6b;
      font-size: 16px;
      border-bottom: 2px solid #e3e7ec;
      padding-bottom: 10px;
    }
    .leftContext {
      margin-top: 10px;
      border: 1px solid#E3E7EC;
    }
  }
  .right {
    overflow: auto;
    flex: 1;
    background: #fff;
    padding: 10px;
    margin-left: 10px;
    min-width: 400px;
    .title {
      color: #6b6b6b;
      font-size: 16px;
      border-bottom: 2px solid #e3e7ec;
      padding-bottom: 10px;
    }
    .rightContext {
      margin-top: 10px;
      border: 1px solid#E3E7EC;
    }
  }
}
.codeInfo {
  display: flex;
  justify-content: space-around;
  margin-top: 10px;
  div {
    font-size: 15px;
    color: #666;
  }
}
/deep/.el-table th > .cell {
  color: #333;
}
/deep/.el-form-item {
  margin-bottom: 10px;
}
.liimg {
  position: relative;
  display: inline-block;
  margin-right: 12px;
  width: 80px;

  p {
    text-align: center;
    font-size: 12px;
    color: #666;
  }

  .close {
    position: absolute;
    top: -20px;
    right: -10px;
    z-index: 10;
  }

  .close:hover {
    cursor: pointer;

    i {
      color: #006af1;
    }
  }

  .img-avatar {
    width: 80px;
    height: 80px;
    border-radius: 5px;
  }
}

.selectTree {
  width: 100%;
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
  height: 30px;

  /deep/.el-cascader .el-input .el-input__inner {
    line-height: 30px;
    height: 30px;
    width: 100%;
  }
  /deep/.el-cascader .el-input {
    width: 250px;
  }
  /deep/.vue-treeselect {
    height: 30px;
  }
  /deep/.vue-treeselect--searchable .vue-treeselect__input-container {
    height: 30px;
    line-height: 30px;
  }
  /deep/.vue-treeselect__single-value {
    font-size: 14px;
    line-height: 30px;
  }
  /deep/.vue-treeselect__menu-container {
    font-size: 15px;
  }
  /deep/.vue-treeselect__multi-value-item {
    height: 20px;
    line-height: 20px;
    padding: 0;
  }
  /deep/.vue-treeselect__input {
    height: 28px;
    line-height: 28px;
    outline: none;
    border: none;
    padding: 0;
    // display: none;
    // border:1px solid #000;
  }
  /deep/.vue-treeselect__placeholder {
    font-size: 10px;
    line-height: 28px;
  }
  /deep/.vue-treeselect--has-value .vue-treeselect__multi-value {
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  /deep/.vue-treeselect__control {
    height: 30px;
  }
}
</style>